<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3>Lock Funds</h3>
      <p class="sub-text fnt-14">{{ plan.name }}</p>
      </div>
    </div>
    <div class="content">
      <div v-if="pageLoading" class="text-center mt-5">
        <vue-loaders-ball-pulse color="red" scale=".75"></vue-loaders-ball-pulse>
        <p class="loadingText">Please wait</p>
      </div>
      <div v-else>
        <div>
          <div class="balances">
            <div class="account_balance cabin-family">
              <p class="fnt-14">Locked Fund</p>
              <p class="bold">₦ {{ Number(balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>

            <div class="account_balance2 cabin-family">
              <p class="fnt-14">Accrued Interest</p>
              <p class="bold">₦ {{ Number(interest).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>
          </div>

          <p class="open-sans bold">Description</p>
          <p>{{ plan.description }}</p>

          <div class="mt-3">
            <p class="open-sans bold">History</p>
            <div class="trans-table">
              <div class="trans-table-row" v-for="(saving, ind) in savings.slice().reverse()"
              :key="ind">
              <div class="row2">
                  <p class="p1">Savings amount</p>
                  <p class="p2">₦{{ Number(saving.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>

                  <p class="p1">Accrued Interest</p>
                  <p class="p2">₦{{ Number(saving.savings_interest).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                </div>
                <div class="row1">
                  <p class="p1">Date Created</p>
                  <p class="p2">{{ saving.createdAt | formatDate}}</p>

                  <p class="p1">Maturity Date</p>
                  <p class="p2">{{ saving.maturity_date | formatDate}}</p>
                </div>
              </div>
            </div>
          </div>
          <br>
          <form @submit="saveFund">
            <div class="form-group">
              <label class="open-sans bold">Amount to Lock</label>
              <input type="number" v-model="amount" placeholder="Amount" class="form-control"
              required>
            </div>
            <button class="btn primary-btn btn-block open-sans" :disabled="isDisabled">
            <span v-if="!loading">Lock Fund</span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader></button>
          </form>
        </div>
      </div>
    </div>
    <success-component v-if="showSuccess" :message="successMsg" @close="closePrompt">
    </success-component>
    <error-component v-if="showError" :message="errorMsg" @close="closePrompt"></error-component>
    <prompt-component v-if="showPrompt" :message="promptMsg" @yes="yes" @no="no"
    :yes="'Add to existing'" :no="'Create new'"></prompt-component>
  </div>
</template>

<script>
import ErrorComponent from '../components/Error.vue';
import SuccessComponent from '../components/Success.vue';
import PromptComponent from '../components/Prompt.vue';
import { withWalletTypeData, withWalletTypeParams } from '../utils/walletType';

export default {
  props: ['id'],
  components: {
    ErrorComponent,
    SuccessComponent,
    PromptComponent,
  },
  created() {
    this.getPlan();
  },
  computed: {
    isDisabled() {
      if (!this.amount || (this.walletBalance < this.amount)) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      plan: {},
      showSuccess: false,
      showError: false,
      showPrompt: false,
      pageLoading: true,
      balance: 0,
      interest: 0,
      amount: 0,
      walletBalance: 0,
      savings: [],
      loading: false,
      transactions: [],
      errorMsg: '',
      successMsg: '',
      promptMsg: '',
      topUp: false,
    };
  },
  methods: {
    async getPlan() {
      this.pageLoading = true;
      const params = withWalletTypeParams(this.$store);
      const url = `${this.$baseUrl}/savings/plan/${this.id}`;
      const res = await this.$http({ url, method: 'GET', params });
      this.plan = res.data.plan;
      this.balance = res.data.balance;
      this.interest = res.data.interest;
      this.savings = res.data.savings;
      this.walletBalance = res.data.walletBalance;
      this.pageLoading = false;
    },
    yes() {
      this.topUp = true;
      this.showPrompt = false;
      this.lockFund();
    },
    no() {
      this.topUp = false;
      this.showPrompt = false;
      this.lockFund();
    },
    saveFund(e) {
      e.preventDefault();
      this.promptMsg = 'Do you want to add this to the existing locked fund or create a new one?';
      this.showPrompt = true;
    },
    async lockFund() {
      this.loading = true;
      try {
        const data = withWalletTypeData(this.$store, {
          amount: this.amount,
          planId: this.id,
          topUp: this.topUp,
        });
        const url = `${this.$baseUrl}/funds/lock`;
        await this.$http({ url, data, method: 'POST' });
        this.amount = '';
        this.successMsg = 'Funds Locked Successfully';
        this.getPlan();
        this.showSuccess = true;
        this.loading = false;
      } catch (error) {
        this.errorMsg = error.response.data.message;
        this.showError = true;
        this.loading = false;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    },
    back() {
      this.$router.go(-1);
    },
    closePrompt() {
      this.showError = false;
      this.showSuccess = false;
      this.showCoopPop = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  a{
    color: #EE0E4C;
    font-weight: 400;
  }
  p {
    margin-bottom: .25rem;
  }
  .balances{
    display: flex;
    justify-content: space-between;
  }
  .account_balance{
    margin: 0 0 1rem 0;
    background-color: #EE0E4C;
    color: #FFF;
    padding: .5rem;
    text-align: center;
    font-size: 20px;
    line-height: 1;
    border-radius: 8px;
    width: 45%;
  }
  .account_balance2{
    margin: 0 0 1rem 0;
    background-color: #FFF;
    border: 1px solid #EE0E4C;
    color: #EE0E4C;
    padding: .5rem;
    text-align: center;
    font-size: 20px;
    line-height: 1;
    border-radius: 8px;
    width: 45%;
  }
  .trans-table{
    padding: 1rem;
    border-radius: 8px;
    background-color: #FFF;
    &-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .75rem 0;
      border-bottom: 1px solid #E5E5E5;
      &:last-child{
        border-bottom: none;
      }
    }
    .p1{
      font-size: 11px;
      line-height: 12px;
      color: #49566A;
      font-family: 'Cabin', sans-serif;
    }
    .p2{
      font-family: 'Cabin', sans-serif;
      font-weight: 600;
      font-size: 14px;
    }
  }
  .transactions{
    margin-top: 1rem;
  }
  form{
    margin-bottom: 2rem;
  }
  .notification{
    text-align: center;
    font-family: 'Cabin', sans-serif;
    font-weight: 600;
    font-size: 16px;
    // margin-top: 2rem;
    p{
      margin-bottom: 1rem;
    }
  }
  .loadingText{
    font-size: 20px;
  }
  .success-label{
    background-color: rgba($color: #50A948, $alpha: 0.2);
    color: #50A948;
    padding: .25rem;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
  }
  .process-label{
    background-color: #FFDDE6;
    color: #EE0E4C;
    padding: .25rem;
    border-radius: 8px;
    font-weight: 400;
    font-size: 11px;
    text-align: center;
  }
  .empty-trans{
    margin-top: 2rem;
    text-align: center;
    color: #6b6b6b;
  }
</style>
